import { Directive, Input, OnInit, Optional, Self, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ListFilterComponent } from '../list-filter.component';

@Directive({
    selector: '[clear-fields]'
})
export class ClearFieldsDirective implements OnInit {
    @Input('clear-fields') clearFields = '';

    constructor(@Optional() @Self() private ngCtrl: NgControl, private listFilterCmp: ListFilterComponent, private inject: Injector) { }

    ngOnInit() {
        if (this.clearFields && this.ngCtrl) {
            this.ngCtrl.valueChanges.subscribe((v) => {
                if (!this.ngCtrl.dirty) {
                    return;
                }
                this.listFilterCmp.fieldCodeOfClearFields = [];
                this.clearFields.split(',').forEach(n => {
                    // 字段编号
                    const conditionItem = this.listFilterCmp.listFilterConditions.find(c => c.fieldCode === n);
                    if (conditionItem) {
                        // 触发清空字段列表变更，特殊控件类型的清空，不能只是清空值
                        this.listFilterCmp.fieldCodeOfClearFields.push(n);
                        // 清空字段
                        conditionItem.value.clearValue();
                    }
                });
            });
        }
    }
}
